import { Table } from 'react-bootstrap'
import { usePermissionsQuery } from '@data/rbac/rbac'

import './PermissionsComponent.scss'

const PermissionsComponent = () => {
  const { data: permissions = [], isLoading: loading } = usePermissionsQuery()

  return (
    <div>
      {loading ? (
        'Loading...'
      ) : (
        <>
          <Table>
            <thead>
              <tr>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {permissions.map((permission) => (
                <tr key={permission.name}>
                  <td>{permission.description}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  )
}

export default PermissionsComponent
